// extracted by mini-css-extract-plugin
export default {"card":"Tile_card__WlW3G","inactivecard":"Tile_inactivecard__Eg0Uj","cardWrap":"Tile_cardWrap__eOMFp","titleLink":"Tile_titleLink__nQzaP"};